import React, { useState } from 'react';
import { Card, CloseButton, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ConfirmationModal } from '../../../../../shared/components/modal/ConfirmationModal';
import { CustomImageHandler } from '../../../../../shared/components/CustomImageHandler';
import { RatingStar } from '../../../../../shared/components/RatingStar';
import { getSocialIcons } from '../../../../../shared/functions/Functions';
import { numberFormatter } from '../../../../../utils/helpers/numberFormater';
import { priceSplitter } from '../../../../../utils/helpers/priceSplitter';
import { IContract } from '../../../../../model/shared/IContract';
import { BookingContractModal } from '../contract/modal/BookingContractModal';

interface ICheckoutCardProps {
    bookingStatus: string;
    contracts?: IContract[];
    deselectContract: (offerId: number) => void;
    acceptContract?: (offerId: number) => void;
    declineContract?: (offerId: number) => void;
}

export function CheckoutCard({
    bookingStatus,
    contracts,
    deselectContract,
    acceptContract,
    declineContract,
}: ICheckoutCardProps) {
    const { t } = useTranslation();
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [showBookingModal, setShowBookingModal] = useState(false);
    const [contractId, setContractId] = useState(0);
    const [userId, setUserId] = useState(0);
    const openModal = (id: number, user: number) => {
        setContractId(id);
        setUserId(user);
        setShowBookingModal(true);
    };
    const closeModal = () => {
        setShowBookingModal(false);
    };
    return (
        <>
            <ConfirmationModal
                title={t('brand.campaign.book.offer.modal.are_you_sure')}
                description={t('brand.campaign.book.checkout.removeOffer')}
                show={showConfirmationModal}
                action={() => deselectContract(contractId)}
                closeModal={() => setShowConfirmationModal(false)}
            />
            <BookingContractModal
                show={showBookingModal}
                closeModal={closeModal}
                contractId={contractId}
                userId={userId}
                acceptContract={acceptContract}
                declineContract={declineContract}
                selectContract={deselectContract}
            />
            {contracts?.map(contract => (
                <Col key={contract.id} lg={6} className="pl-0 pr-0 pr-md-3">
                    <Card
                        className={`booking-card flex column flex-md-row align-items-center justify-content-between default-border p-2 ${
                            bookingStatus === 'selected' ? 'border-selected' : 'border-completed'
                        } my-2`}
                    >
                        <div
                            className="d-flex cursor-pointer"
                            onClick={() => openModal(contract?.id, contract?.user?.id)}
                        >
                            <CustomImageHandler
                                altTag={`${contract?.user?.profilePhoto?.name ?? ''}`}
                                classes="user-img-rounded-lg box-shadow-angle m-1"
                                thumbnailPath={contract?.user?.profilePhoto?.thumbnail}
                                photoPath={contract?.user?.profilePhoto?.thumbnail ?? ''}
                                name={contract?.user?.displayName}
                            />
                            <div className="p-2 pl-3 d-flex align-items-start justify-content-center flex-column">
                                <span className="font-weight-semi-bold">{contract?.user?.displayName}</span>
                                {!!contract?.user?.totalRating ? (
                                    <RatingStar rating={contract?.user?.totalRating} />
                                ) : (
                                    ''
                                )}
                            </div>
                        </div>
                        <div className="d-flex  align-items-center align-items-md-end justify-content-between flex-column flex-md-row">
                            {!!contract?.totalPlatforms?.length && (
                                <div
                                    className="d-flex align-items-center my-2 my-md-0 ml-md-2 cursor-pointer"
                                    onClick={() => openModal(contract?.id, contract?.user?.id)}
                                >
                                    <div className="d-flex justify-content-between">
                                        <div className="d-flex flex-wrap justify-content-end justify-content-md-start">
                                            {contract?.totalPlatforms?.map(platform => (
                                                <React.Fragment key={platform?.id}>
                                                    {getSocialIcons({
                                                        iconPath: platform.path,
                                                        dataTop: `x${platform.nbPostsTotal}`,
                                                        dataDown: numberFormatter(platform.followers),
                                                        colorText: 'primary',
                                                        parentClasses: 'mr-2',
                                                    })}
                                                </React.Fragment>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div className="d-flex flex-column ml-2">
                                {bookingStatus === 'selected' && (
                                    <CloseButton
                                        onClick={() => {
                                            setShowConfirmationModal(true);
                                            setContractId(contract?.id);
                                        }}
                                    />
                                )}
                                <span className="bg-light rounded font-weight-bold px-2 my-2 euro-symbol">
                                    {priceSplitter(Math.round(contract.price ?? 0))}
                                </span>
                            </div>
                        </div>
                    </Card>
                </Col>
            ))}
        </>
    );
}
